// extracted by mini-css-extract-plugin
export default {"product__item":"MyOrderProduct_product__item__BNN-G","product__title":"MyOrderProduct_product__title__dbwYV","product__img":"MyOrderProduct_product__img__UNx5c"};